export const successMessageText = "Record added successfully!",
  errorMessageText = "Something went wrong!",
  responseErrorMessage = "Could not fetch the data for the resource",
  noPrescriptionFound = "No prescription found",
  DefaultNotDispenseOutOfScopeCode = "0007",
  DefaultNotDispenseExpiredCode = "0008",
  DefaultNotDispenseCancelledCode = "0099",
  DefaultNotDispensePatientDeceasedCode = "0005",
  DefaultClinicallyNotSuitableCode = "0002",
  accessInviteUsers = "access:invite-users",
  accessAddTeams = "access:add-team",
  accessEmailTemplate = "access:add-email-template",
  accessAddService = "access:create-service",
  accessOwner = "access:owner",
  accessAgencyUser = "access:agency-user",
  accessBetaUser = "access:beta-user",
  siteName = "beta",
  deleteConfirmationMessage = "Are you sure you want to delete this ",
  leaveConsultation =
    "Patient consultation is in progress. Are you sure you want to leave?",
  leaveConsultationTitle = "Leave Consultation",
  intercomActionPatientImportText = "patient-import",
  intercomActionPatientAddText = "patient-add",
  intercomActionDocumentAddText = "company-document-add",
  intercomActionDocumentUpdateText = "company-document-update",
  intercomActionPrescriptionText = "prescription-add",
  intercomActionPatientDocumentText = "patient-document-add",
  accessTitanversePatientUpsert = "titanverse.patients.upsert",
  accessTitanversePatientView = "titanverse.patients.view",
  accessTitanverseCalenderUpsert = "titanverse.calendar.upsert",
  accessTitanverseCalenderView = "titanverse.calendar.view",
  accessTitanverseTemplateUpsert = "titanverse.templates.upsert",
  accessTitanverseTemplateView = "titanverse.templates.view",
  accessTitanverseApprovalView = "titanverse.approval.prescription.view",
  accessTitanversePrescriptionApproval =
    "titanverse.approval.prescription.approve",
  accessTitanversePrescriptionUpsert = "titanverse.prescriptions.upsert",
  accessTitanversePrescriptionView = "titanverse.prescriptions.view",
  accessTitanversUserView = "titanverse.users.view",
  accessTitanversUserUpsert = "titanverse.users.upsert",
  accessTitanverseTeamView = "titanverse.teams.view",
  accessTitanverseTeamUpsert = "titanverse.teams.upsert",
  accessTitanverseConsultationUpsert = "titanverse.consultations.upsert",
  accessTitanverseConsultationView = "titanverse.consultations.view",
  accessTitanverseDocumentsUpsert = "titanverse.documents.upsert",
  accessTitanverseAnalyticsView = "titanverse.analytics.view",
  accessTitanverseFullAccess = "titanverse.admin.fullsystemaccess",
  accessTitanverseManageSettings = "titanverse.manage.settings",
  nhs111ServiceId = "69247f74b7536cef065c6a2f",
  bmiVitalLabel = "BMI Calculator",
  nhs111TemplateId = "698c75f22be7756dd5ff9cb3",
  checkRefreshStatusTimeDifference = "2",
  nhsContraceptionTemplateId = "69ef650d8708b5fbbb925e20",
  nhsContraceptionServiceId = "65f3a8c2e91b4d7f2a6c9b10",
  nhsSinusitisTemplateId = "6a2f3b4c5d6e7f8a9b0c1d2e",
  nhsSinusitisServiceId = "6a2f3b4c5d6e7f8a9b0c1d2f",
  nhsSoreThroatTemplateId = "6a2f3b4c5d6e7f8a9b0c1d30",
  nhsSoreThroatServiceId = "6a2f3b4c5d6e7f8a9b0c1d31",
  nhsImpetigoTemplateId = "6a2f3b4c5d6e7f8a9b0c1d32",
  nhsImpetigoServiceId = "6a2f3b4c5d6e7f8a9b0c1d33",
  nhsInsectBitesTemplateId = "6a2f3b4c5d6e7f8a9b0c1d34",
  nhsInsectBitesServiceId = "6a2f3b4c5d6e7f8a9b0c1d35",
  nhsShinglesTemplateId = "6a2f3b4c5d6e7f8a9b0c1d36",
  nhsShinglesServiceId = "6a2f3b4c5d6e7f8a9b0c1d37",
  nhsUtiTemplateId = "6a2f3b4c5d6e7f8a9b0c1d38",
  nhsUtiServiceId = "6a2f3b4c5d6e7f8a9b0c1d39",
  nhsAomTemplateId = "6a2f3b4c5d6e7f8a9b0c1d3a",
  nhsAomServiceId = "6a2f3b4c5d6e7f8a9b0c1d3b",
  nhsHypertensionStage1TemplateId = "6a201203b674e54909b40fa5",
  nhsHypertensionStage1ServiceId = "6a219eddfc20758b500f8f99",
  nhsHypertensionABPMFittingTemplateId = "6a26ee251a3c42edecb8bad4",
  nhsHypertensionABPMFittingServiceId = "6a26ee3908171203e0ef0e02",
  nhsHypertensionABPMFollowupTemplateId = "6a313674e4009397000bc6c3",
  nhsHypertensionABPMFollowupServiceId = "6a313690760a198eeb5db609",
  nhsMinorIllnessTemplateId = "6a427c174a7efa04ea867fe1",
  nhsMinorIllnessServiceId = "6a427c574104b5c34e345d02",
  nhsAhtWeightTemplateId = "6a4f8b2c3d5e6f7a8b9c0d1e",
  nhsAhtWeightServiceId = "6a4f8b2c3d5e6f7a8b9c0d1f",
  nhsAhtFollowUpTemplateId = "6a4f8b2c3d5e6f7a8b9c0d20",
  nhsAhtFollowUpServiceId = "6a4f8b2c3d5e6f7a8b9c0d21",
  nhsAhtSixMonthTemplateId = "6a4f8b2c3d5e6f7a8b9c0d22",
  nhsAhtSixMonthServiceId = "6a4f8b2c3d5e6f7a8b9c0d23",
  nhsAhtTravelHealthTemplateId = "6a4f8b2c3d5e6f7a8b9c0d24",
  nhsAhtTravelHealthServiceId = "6a4f8b2c3d5e6f7a8b9c0d25";
